<div class="component-container flex flex-col justify-center items-center">
  <div class="display-section grid grid-cols-1">
    <ng-container
      *ngFor="let eachQuestion of obQuestions">
      <div
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12 flex items-center">
          <div>
            <span>{{ eachQuestion.question }}</span>
            <app-icon *ngIf="eachQuestion.tooltipText"
                      [matTooltip]="eachQuestion.tooltipText"
                      class="tooltip-icon"
                      matTooltipClass="custom-tooltip"
                      matTooltipPosition="below"
                      svgIcon="info"></app-icon>
          </div>

        </div>
        <div class="value w-6/12">
          {{ eachQuestion.selectedOptionValue || eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        eachQuestion.questionKey === 'selfDescribe')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other race
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        eachQuestion.questionKey === 'undergraduateDegrees')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other undergraduate degree (abbreviation)
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        eachQuestion.questionKey === 'masterDegrees')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other Master's degree (abbreviation)
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        eachQuestion.questionKey === 'doctorateDegrees')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other Doctorate degree (abbreviation)
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        eachQuestion.questionKey === 'professionalLicenses' )"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other professional license and/or certification (abbreviation)
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 1 &&
        eachQuestion.questionKey === 'whatDoYouLikeToBeCalled')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 1 &&
        eachQuestion.questionKey === 'preferredLaguage')"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other preferred language
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        (eachQuestion.questionKey === 'medicalInsurance'))"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other health insurance or health coverage plan:
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        (eachQuestion.questionKey === 'organizationType'))"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Organization Description
        </div>
        <div class="value w-6/12">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 1 &&
        (eachQuestion.questionKey === 'medication'))"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other Medication
        </div>
        <div class="value w-6/12 show-white-space">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>

      <div
        *ngIf="eachQuestion.otherValue && (eachQuestion.answerType == 2 &&
        (eachQuestion.questionKey === 'medicalProblems'))"
        class="row flex flex-row gap-[1.5rem] justify-start items-start"
      >
        <div class="label w-6/12">
          Other medical problem
        </div>
        <div class="value w-6/12 show-white-space">
          {{ eachQuestion.otherValue  }}
        </div>
      </div>
    </ng-container>

  </div>
  <div class="action-section flex flex-row
              justify-end items-center md:mr-[12rem] mr-[0]">
    <app-primary-button
      (handleClick)="editOnboardingDetails()"
      class="edit-button w-[7.5rem]"
      type="small"
    >
      Edit
    </app-primary-button>
  </div>
</div>
